import { memo } from "react";

function Navbar() {
  return (
    <nav className="nav">
      <div className="brand">
        <span className="dev">Dev</span>
        <span className="sub">.daniel</span>
      </div>
      <div className="nav-links">
        <a href="#markour">Markour</a>
        <a href="#bluelink">Bluelink</a>
        <a href="#nextcloud">Nextcloud</a>
        <a href="#pts">PTS</a>
        <a href="#devcon">DevCon1</a>
        <a href="#about">About</a>
        <a className="nav-cta" href="#contact">
          Contact
        </a>
      </div>
    </nav>
  );
}

export default memo(Navbar);
